import i18n from 'utils/i18n'
import type { AdminClustersFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationClustersFiltersCollection = () => [
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineCountryFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineCountryFilter satisfies AdminClustersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.productCountryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.producerFilter),
    filterName:
      ADMIN_FILTERS_NAME.producerFilter satisfies AdminClustersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.tradeNameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.geoIndicationFilter),
    filterName:
      ADMIN_FILTERS_NAME.geoIndicationFilter satisfies AdminClustersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.geoIndicationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.sourceFilter),
    filterName:
      ADMIN_FILTERS_NAME.sourceFilter satisfies AdminClustersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.sourceFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.destinationSourceFilter),
    filterName:
      ADMIN_FILTERS_NAME.destinationSourceFilter satisfies AdminClustersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.destinationSourceFilter,
  },
]

export const adminClustersFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationClustersFiltersCollection,
  pathToStore: [],
  filtersDataPath: ['admin', 'mentions', 'mentionPendingSimilarityFilters'],
  showResultsTextKey: 'filters.button.apply',
  showPresets: false,
}
